enum FlexiRewardsErrorCodes {
  // Flexi Rewards
  PBBulkRewardProcessing = "PBFlexiPointsAppExistingBulkRewardProcessing",
}

export default FlexiRewardsErrorCodes